import React from 'react';
import GlobalErrorsBox from '../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import Label from '../FormElements/Label';
import TextInput from '../FormElements/TextInput';
import Select2DropdownList from '../FormElements/Select2DropdownList';
import FormSection from '../FormElements/FormSection';
import FormSubmit from '../FormElements/FormSubmit';
import LoaderOverlay from '../LoaderOverlay/LoaderOverlay';

export default class EditActionTriggerForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			name: '',
			trigger_type: '',
			webhook_url: '',
			webhook_secret: '',
			globalErrors: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSetFieldError = this.onSetFieldError.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		if (this.props.actionTriggerUrl) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.get_action_trigger_endpoint !==
			this.props.get_action_trigger_endpoint
		) {
			this.loadData();
		}
	}

	render() {
		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						<GlobalErrorsBox globalErrors={this.state.globalErrors} />
						<div className="my-3">
							<Label>{I18n.t('admin.action_trigger_name')}</Label>
							<Select2DropdownList
								style={this.styleTextInputOnError('name')}
								name="name"
								value={this.state.name}
								data={[
									{
										id: 'article_read',
										text: I18n.t('article_read')
									},
									{
										id: 'authenticated',
										text: I18n.t('authenticated')
									},
									{
										id: 'checkup_completed',
										text: I18n.t('checkup_completed')
									},
									{
										id: 'course_added',
										text: I18n.t('course_added')
									},
									{
										id: 'course_removed',
										text: I18n.t('course_removed')
									},
									{
										id: 'course_quiz_passed',
										text: I18n.t('course_quiz_passed')
									},
									{
										id: 'course_quiz_failed',
										text: I18n.t('course_quiz_failed')
									},
									{
										id: 'course_progress_completed',
										text: I18n.t('course_progress_completed')
									}
								]}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
							{/* <TextInput
                style={this.styleTextInputOnError("name")}
                placeholder=""
                name="name"
                value={this.state.name}
                onChange={this.onChange}
                fieldErrors={this.state.fieldErrors}
              /> */}
						</div>
						<div className="mt-3">
							<Label>{I18n.t('admin.action_trigger_type')}</Label>
						</div>
						<div className="mb-3">
							<Select2DropdownList
								style={this.styleTextInputOnError('trigger_type')}
								name="trigger_type"
								value={this.state.trigger_type}
								data={[
									{
										id: -1,
										text: I18n.t('admin.action_trigger_type')
									},
									{
										id: 'WEBHOOK',
										text: 'Webhook'
									}
								]}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.action_trigger_webhook_url')}</Label>
							<TextInput
								style={this.styleTextInputOnError('webhook_url')}
								placeholder=""
								name="webhook_url"
								value={this.state.webhook_url}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.action_trigger_webhook_secret')}</Label>
							<TextInput
								style={this.styleTextInputOnError('webhook_secret')}
								placeholder=""
								name="webhook_secret"
								value={this.state.webhook_secret}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
					</FormSection>
					<FormSubmit
						text={
							this.props.userActionTriggerRequest === 'add' ? (
								I18n.t('admin.create_action_trigger_button')
							) : this.props.userActionTriggerRequest === 'edit' ? (
								I18n.t('admin.update_action_trigger_button')
							) : (
								'Submit'
							)
						}
					/>
				</form>
				{this.state.loading ? <LoaderOverlay /> : null}
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors) {
			if (fieldName in this.state.fieldErrors) {
				return { border: '1px solid #ff3d60', borderRadius: '5px' };
			}
		}
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSetFieldError(errorsArray, error) {
		if (errorsArray.includes(error)) {
			return 'Error';
		}
	}

	onSubmit(e) {
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true,
			globalErrors: null,
			fieldErrors: null
		});

		$.ajax({
			type: 'POST',
			url:
				this.props.userActionTriggerRequest === 'add'
					? this.props.create_action_trigger_endpoint
					: this.props.userActionTriggerRequest === 'edit'
						? this.props.update_action_trigger_endpoint
						: '',
			data: {
				name: this.state.name,
				trigger_type: this.state.trigger_type,
				webhook_url: this.state.webhook_url,
				webhook_secret: this.state.webhook_secret,
				action_trigger_url: this.props.actionTriggerUrl
			},
			dataType: 'json'
		}).done((data) => {
			if (data.success === true) {
				this.setState({
					loading: false
				});
				this.props.onHidePopup();
				this.props.onShowSuccessCardPopup(
					this.props.userActionTriggerRequest === 'add'
						? 'add'
						: this.props.userActionTriggerRequest === 'edit' ? 'edit' : ''
				);
				this.props.onActionCompleted(this.props.isActionComplete);
			} else if (data.status == 'session_expired') {
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				this.setState({
					loading: false,
					globalErrors: data.errors.global,
					fieldErrors: data.errors.fields
				});
			}
		});
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'GET',
			url: this.props.get_action_trigger_endpoint,
			data: {
				action_trigger_url: this.props.actionTriggerUrl
			}
		}).done((payload) => {
			const result = payload;
			this.setState({
				loading: false,
				name: result.data.name,
				trigger_type: result.data.trigger_type,
				webhook_url: result.data.webhook_url,
				webhook_secret: result.data.webhook_secret
			});
		});
	}
}
